import { Component, OnInit, EventEmitter, ViewChild, Output, OnChanges, Input, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { PhBhpFilterComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-filter/ph-bhp-filter.component';
import { Subscription } from 'rxjs';
import { SopDetail } from 'ph-bhp-feature-packages/ph-bhp-feature-package-elearning/lib/Models';
import { PHBHPFeaturePackageEvaluationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from 'src/app/app.config';
import { PHBHPFeaturePackageEvaluationFilterService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-feature-package-evaluationfilter.service';
import { fiveMomentsMap } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-asepticprocedures.service';
import { TranslationKeys } from 'ph-bhp-localization';
import { PhBhpPdfComplianceMultiFilterComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-pdf-compliance-multi-filter/ph-bhp-pdf-compliance-multi-filter.component';
import { PhBhpBarChartComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-bar-chart/ph-bhp-bar-chart.component';
import { PhBhpPdfComplianceMultiFilterObserveComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-pdf-compliance-multi-filter-observe/ph-bhp-pdf-compliance-multi-filter-observe.component';
import cloneDeep from 'lodash/cloneDeep';
import { PhBhpObserveChartExportComponent } from '../ph-bhp-observe-chart-export/ph-bhp-observe-chart-export.component';
@Component({
  selector: 'lib-ph-bhp-observe-fivemoments',
  templateUrl: './ph-bhp-observe-fivemoments.component.html',
  styleUrls: ['./ph-bhp-observe-fivemoments.component.css']
})
export class PhBhpObserveFivemomentsComponent implements OnInit, OnChanges, OnDestroy {
  translationKeys: typeof TranslationKeys = TranslationKeys;
  private static readonly INITIAL_FIELDS = [
    { 'field': 'name', 'title': 'CONFIGURE.DESCRIPTION' }
  ];
  pageTitle: string;
  textLegend: string;
  fiveMomentsMap: any[];
  langSubscription: Subscription;
  institutionSubscription: Subscription;
  compareCard;
  tempFilter;
  showCompareCard;
  singleCard;
  data;
  filterDetails = [];
  isDesktop = true;
  isAdjustableHeight = true;
  @ViewChild('compliance', { static: true }) compliance: PhBhpPdfComplianceMultiFilterObserveComponent;
  @ViewChild('exportTag', { static: true }) exportTag: PhBhpObserveChartExportComponent;
  @ViewChildren(PhBhpFilterComponent) filters: QueryList<PhBhpFilterComponent>;
  @ViewChildren(PhBhpBarChartComponent) charts: QueryList<PhBhpBarChartComponent>;
  initFlag = true;
  sopiDs: Array<any> = [];
  isSavedFromEvaluation: boolean;
  noDataFound: boolean = false;
  percentageLegend = "{0}%";
  complianceType;
  labels;
  pageInfo = {
    ofLabel: 'GENERAL.OF',
    items: 'GENERAL.ITEMS',
    itemsPerPageLabel: 'GENERAL.ITEMS_PAGE'
  };

  public clickImageBtn = false;
  public clickExcelBtn = false;
  public clickPdfBtn = false;

  isCallFor;
  sopDetail: SopDetail[];

  userSubscription: Subscription;
  //'5 Moments';
  userID;
  roleId;
  appName = 'Observe';
  filterIndices: number[] = [0];
  evaluationLoaded: boolean = false;
  isBenchmark: boolean = false;
  originalData: any;
  fiveMomentsResponse: any;
  isEvaluationTable: boolean = true;

  multiSelectText: string = '';
  results: any = [];
  isUserFilterSetted: boolean = false;
  userHasFilter: boolean = false;
  userFilters: any;
  sopFilters: any[] = [];

  constructor(
    public appConfig: AppConfig,
    private router: Router,
    private evaluationService: PHBHPFeaturePackageEvaluationService,
    private layoutService: PHBHPLayoutPackageService,
    private filterService: PHBHPFeaturePackageEvaluationFilterService) {
    this.fiveMomentsMap = fiveMomentsMap;
    this.textLegend = this.layoutService.translateText("EVALUATION.FIVE_MOMENTS");
    this.appConfig.filterDetails ? this.filterDetails = this.appConfig.filterDetails : this.filterDetails = [];
  }

  ngOnInit(): void {
    this.userID = this.appConfig.userData.userId;
    this.roleId = this.appConfig.userData.roleName.roleId;
    this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      setTimeout(() => {
        for (let i = 0; i < this.charts.length; i++) {
          let chart = this.charts.get(i);
          chart.chartOptions.valueAxis.title.text = this.textLegend;
        }

        this.pageTitle = this.layoutService.translateText(this.translationKeys.Dashboard.FiveMoments);
        this.compliance.complianceTitle = this.layoutService.translateText(this.translationKeys.Dashboard.FiveMoments);

        //Generate again labels for charts and tables
        this.evaluate(true);

        this.layoutService.showLoader = false;
      }, 1000);
    });

    this.pageTitle = this.layoutService.translateText(this.translationKeys.Dashboard.FiveMoments);
    this.compliance.complianceTitle = this.layoutService.translateText(this.translationKeys.Dashboard.FiveMoments);
    this.ngOnChanges();
  }

  ngOnChanges() {
    this.layoutService.showLoader = true;
    this.userHasFilter = false;
    if (!this.isUserFilterSetted) {
      this.evaluationService.getUserHasObserveEvaluationFilter(this.appConfig.userData.userId, 'fivemoments').subscribe((userHasFilter) => {
        this.isUserFilterSetted = true;
        if (userHasFilter) {
          this.userHasFilter = true;
          this.userFilters = JSON.parse(userHasFilter.filterList);
          this.userFilters = this.userFilters.Filter;
          setTimeout(() => { this.initComponent(); });
        } else {
          this.userFilters = [];
          this.noDataFound = true;
          this.filters.get(0).showFilter(true);
          this.compliance.resultsLoader.next([{}]);
        }
      }, (error) => { }, () => { this.layoutService.showLoader = false; });
    } else {
      setTimeout(() => { this.initComponent(); });
    }
  }

  ngOnDestroy() {
    if (this.langSubscription)
      this.langSubscription.unsubscribe();
    if (this.userSubscription)
      this.userSubscription.unsubscribe();
    if (this.institutionSubscription)
      this.institutionSubscription.unsubscribe();
  }

  initComponent() {

    if (this.userFilters.length > 0) {
      this.userFilters.forEach((filter, idx) => {
        if (!filter.filterName || filter.filterName.trim() === "") {
          filter.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (idx + 1);
        }
      });
      this.filterIndices = this.userFilters.map((_, index) => index);
      this.showCompareCard = this.filterIndices.length > 1;
    }

    if (this.appConfig.userData) {
      for (let i = 0; i < this.charts.length; i++) {
        let chart = this.charts.get(i);
        chart.chartOptions.valueAxis.labels = {
          format: this.percentageLegend
        };
        chart.chartOptions.valueAxis.title = {
          text: this.layoutService.translateText(this.translationKeys.Dashboard.FiveMoments),
          font: "9px OpenSans-Regular"
        };
      }

      this.compliance.showFilter = true;
      this.compliance.complianceTitle = this.pageTitle;
      this.compliance.roleId = this.roleId;
      this.compliance.fillWith = 'N/A';
      this.loadFiltersInfo();
      if (this.userFilters && this.userFilters.length >= 2 && this.isDesktop) {
        this.showCompareCard = this.filterIndices.length > 1;
        this.compliance.showCompareCard = this.showCompareCard;
        this.tempFilter = this.userFilters;
      }

      this.evaluate(true, true);
    }
  }

  evaluate(getResults, initialize?) {
    this.printConfig();
    const momentsChecked = this.fiveMomentsMap.reduce((acc, moment) => ({ ...acc, [moment.key]: moment.checked }), {});
    this.data = {
      filter: [],
      isBenchMark: true,
      fiveMomentsShown: momentsChecked,
      roleId: this.roleId
    };

    if (initialize) {
      this.data.filter = this.userFilters;
    } else {
      this.filters.forEach((filter) => {
        let filterData: any = {
          startDate: filter.range.start,
          endDate: filter.range.end,
          instutionIDs: "",
          departmentID: "",
          wardID: "",
          professionalCategoryID: "",
          subprofessionalCategoryID: "",
          countryID: 0
        };

        if (this.roleId == 1 && filter.setCountry != 0) {
          filterData.countryID = filter.setCountry.countryID
        }

        filterData = filter.assignData(filterData);
        this.data.filter.push(filterData);
        if (filterData.multiSelectName) {
          this.multiSelectText = filterData.multiSelectName;
        }
      });
    }

    this.compliance.setFilters(this.filters.toArray());
    this.userHasFilter = true;
    if (getResults == true) {
      this.getFiveMomentsFilterDetails(this.userID, this.data);
    } else if (getResults == false) {
      this.saveFiveMomentsDetails(this.userID, this.data)
    }
  }

  async loadFiltersInfo() {
    setTimeout(() => {
      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        if (this.roleId == 1) {
          filterComponent.setSAFilter(filter, true);
        } else {
          filterComponent.setFilterNameFilter(filter.filterName, true);
          filterComponent.setCountryFilter(filter.CountryID, '', '', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          if (filterComponent.wardListLoaded && filterComponent.wardListLoaded.length > 0) {
            filterComponent.onWardChange(filterComponent.wardListLoaded.find(ward => ward.wardID == filter.wardID));
          }

          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.subprofessionalCategoryID, true);
          if (filter.multiselect) {
            filterComponent.setMultiFilter(filter.multiselect, filter.multiSelectFilter, filter.multiSelectValues, true);
          }
        }
      });
    }, 500);
  }

  resetExportAs(value: 'image' | 'excel' | 'pdf') {
    switch (value) {
      case 'image':
        this.clickImageBtn = false;
        break;
      case 'excel':
        this.clickExcelBtn = false;
        break;
      case 'pdf':
        this.clickPdfBtn = false;
        break;
    }
  }

  emitData(valve) {
    if (valve.value) {
      this.appConfig.filterDetails = valve.value;
      this.appConfig.dropdownChanged = "changed";
    } else {
      this.appConfig.filterDetails = [];
    }
    switch (valve.key) {
      case 'back': this.router.navigate(['evaluation/observeObservation/statistical']); break; // this._location.back();
      case 'overallCompliance': this.router.navigate(['evaluation/observe/overallCompliance']); break;
      case '5Moments': this.router.navigate(['evaluation/observe/fivemoments']); break;
      case 'individualData': this.router.navigate(['evaluation/observe/individualOverview']); break;
      case 'beforeAsepticProcedures': this.router.navigate(['evaluation/observe/StatisticsBeforeAsepticProcedures']); break;
      case 'comments': this.router.navigate(['evaluation/observe/comments']); break;
      case 'quota': this.router.navigate(['evaluation/observe/quota']); break;
      default: this.router.navigate(['evaluation/observeObservation/statistical']); break;
    }
  }

  filterCompare() {
    this.compareCard = false;

    if (this.filterIndices.length < 6) {
      this.filterIndices.push(this.filterIndices.length);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    this.layoutService.showLoader = true;
    setTimeout(() => {
      var filters = this.filters.toArray();
      filters[filters.length - 1].setInfoFromFilter(cloneDeep(cloneDeep(filters[filters.length - 2])));
      this.layoutService.showLoader = false;
    }, 500);

    if (!this.userHasFilter) {
      this.filters.get(0).showFilter(true);
      return;
    }
  }

  printConfig() {
    if (this.sopiDs.length == 0) {
      this.compliance.SOPList = this.sopiDs;
      this.compliance.SOPName = undefined;
    } else {
      this.compliance.SOPList = undefined;
      this.compliance.SOPName = this.layoutService.translateText("EVALUATION.All.SOP"); //All SOP
    }
  }

  showFilter(cardType) {
    const showFilter = cardType;
    if (showFilter == 'singleCard') {
      this.singleCard = !this.singleCard;
      this.compareCard = false;
    }
    if (showFilter == 'compareCard') {
      this.compareCard = !this.compareCard
      this.singleCard = false;
    }
  }

  cancelFilter() {
    this.singleCard = false;
    this.compareCard = false;
  }

  saveFiveMomentsDetails(userID, data) {
    this.isCallFor = "Five Moments";
    this.complianceType = "fivemoments";
    this.isSavedFromEvaluation = false;
    this.layoutService.showLoader = true;
    var selectedSeries = JSON.stringify(Array.from(this.selectedSeries))
    this.data.selectedSeries = selectedSeries;
    this.evaluationService.SaveSummarisedDetail(userID, this.isSavedFromEvaluation, this.complianceType, data).subscribe((res: any) => {
      this.layoutService.showLoader = false;
      this.layoutService.showSuccess(this.layoutService.translateText("EVALUATION.SUCCESSFULLY_SAVED_SUMMARISED_REPORT"));
    })
  }

  getFiveMomentsFilterDetails(userID, data) {
    this.complianceType = "fivemoments";
    this.isCallFor = "fivemoments";
    this.isSavedFromEvaluation = true;
    this.layoutService.showLoader = true;
    this.evaluationService.getFiveMomentsDetailsMulti(userID, this.isSavedFromEvaluation, this.isCallFor, data).subscribe((res: any) => {
      this.originalData = JSON.parse(JSON.stringify(res));
      this.fiveMomentsResponse = res;
      this.buildChart(this.fiveMomentsResponse);
    })
  }

  fiveMomentsUsingKeys(shortName, key) {
    if (shortName != 0) {
      return this.fiveMomentsMap.find(res => this.layoutService.translateText(res[key]) == shortName);
    }
    return null;
  }

  updateFiveMomentsShown(isSavedFromEvaluation, userID, data) {
    this.isSavedFromEvaluation = isSavedFromEvaluation;
    this.evaluationService.updateFiveMomentsShown(userID, this.isSavedFromEvaluation, data).subscribe((res: any) => {
    })
  }

  setFilterDetails() {
    if (this.filterDetails.length > 0) {
      if (this.filters) {
        this.filterService.setFiltersValue(this.filterDetails, this.filters.toArray());
      }
    }
  }

  createFilterData(userID: number) {
    const defaultFilterData = {
      startDate: new Date(),
      endDate: new Date(),
      instutionIDs: "",
      departmentID: "",
      wardID: "",
      professionalCategoryID: "",
      subprofessionalCategoryID: "",
      countryID: 0
    };

    const filters = this.filters && this.filters.length > 0 ? this.filters.map(filter => {
      let filterData = { ...defaultFilterData, startDate: filter.range.start, endDate: filter.range.end };
      if (this.roleId === 1 && filter.setCountry !== 0) {
        filterData.countryID = filter.setCountry.countryID;
      }
      return filter.assignData(filterData);
    }) : [defaultFilterData];

    return {
      filter: filters,
      countryID: 0,
      isBenchMark: true,
      userId: userID,
      isSavedFromEvaluation: true,
      fiveMomentsShown: this.fiveMomentsMap.reduce((acc, moment) => ({ ...acc, [moment.key]: moment.checked }), {}),
      roleId: this.roleId
    };
  }

  updateFilters(filters) {
    this.filterIndices = filters.filter.map((_, index) => index);
    this.filters.toArray().forEach((filterComponent, index) => {
      if (filters.filter[index]) {
        let startDate = new Date(filters.filter[index].startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filters.filter[index].endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        filterComponent.setCountryFilter(filters.filter[index].countryID, filters.filter[index].instutionIDs, filters.filter[index].wardID, true);
        filterComponent.setDepartmentFilter(filters.filter[index].departmentID, true);
        filterComponent.setDepartmentTypeFilter(filters.filter[index].departmentTypeID, true);
        filterComponent.setProfessionalCategory(filters.filter[index].professionalCategoryID, filters.filter[index].subprofessionalCategoryID, true);
      }
    });

    setTimeout(() => {
      this.compliance.setFilters(this.filters.toArray());
    }, 1000);

    this.printConfig();

    if (filters.filter.length >= 2 && this.isDesktop) {
      this.showCompareCard = this.filterIndices.length > 1;
      this.compliance.showCompareCard = this.showCompareCard;
      this.tempFilter = filters;
    }
  }

  ngAfterViewChecked() {
    if (this.tempFilter) {
      var tempFilter = this.tempFilter;
      this.tempFilter = undefined;

      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        if (this.roleId == 1) {
          filterComponent.setSAFilter(filter, true);
        } else {
          filterComponent.setCountryFilter(filter.CountryID, '', '', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.subprofessionalCategoryID, true);
          if (filter.multiselect) {
            filterComponent.setMultiFilter(filter.multiselect, filter.multiSelectFilter, filter.multiSelectValues, true);
          }
        }
      });
    }
  }

  checkHasBenchmarkData(res) {
    var isBenchmarkMapped = res.observeEvaluationFiveMomentResultList.map(item => item.isBenchMark);
    return isBenchmarkMapped.includes(true);
  }

  buildChart(res) {
    this.evaluationLoaded = false;
    var colors = [];
    if (!this.shouldHideBenchmarkDataByResponse(res) || this.shouldHideBenchmarkData()) {
      colors = [
        "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"
      ];
    } else {
      colors = [
        "#001689", "url(#benchmark1)", "#40C4FF", "url(#benchmark2)", "#9744FF", "url(#benchmark3)", "#BF44B9", "url(#benchmark4)", "#E57373", "url(#benchmark5)", "#FFB300", "url(#benchmark6)"
      ];
    }

    res = this.adjustResponseForEnvironment(res);
    res = this.filterBenchmarkDataIfWardIsSelected(res);

    let chart: PhBhpBarChartComponent;
    this.results = [];
    const categoryTitle: string = 'DASHBOARD.TOTAL_PERCENT_COMPLIANCE';
    res.forEach(result => {
      if (result.fiveMomentsList.length > 0) {
        let id = result.filterType || 'single';
        if (this.results.findIndex(r => r.id === id) === -1) {
          this.results.push({
            id,
            fiveMomentsList: [],
            gridData: [],
            fields: [...PhBhpObserveFivemomentsComponent.INITIAL_FIELDS],
            benchmarkFields: [...PhBhpObserveFivemomentsComponent.INITIAL_FIELDS],
            noDataFound: true
          });
        }
      }
    });

    this.compliance.resultsLoader.next(Object.assign([], this.results));
    // The timeout is necessary to give the chart QueryList time to load the component
    setTimeout(() => {
      let filterCount: number = 0;
      let benchmarkCount: number = 0;
      let filterTableCount: number = 0;
      let benchmarkTableCount: number = 0;
      res.forEach((fiveMomentsArray: any, index) => {
        let chartId = fiveMomentsArray.filterType || 'single';
        fiveMomentsArray.filterType = chartId;
        let chartIndex = this.results.findIndex(r => r.id === chartId);
        chart = this.charts.get(chartIndex);
        let data = JSON.parse(JSON.stringify(chart.chartOptions));

        if (!data.setId) {
          data.nextIndex = 0;
          data.categoryAxis.categories = [];
          data.categoryAxis.categoryOffset = [];
          data.series = [];
          data.seriesIdentifier = [];
        }

        data.series[data.nextIndex] = { data: [], name: [], dataOffset: [], serieIndex: index };
        data.series[data.nextIndex].color = colors[index];
        data.seriesIdentifier[data.nextIndex] = [];
        chart.chartId = chartId;

        if (fiveMomentsArray.isBenchmark === false) {
          if (fiveMomentsArray.fiveMomentsList.length === 1 && fiveMomentsArray.fiveMomentsList[0].list.length === 0 && chart.noDataFound) {
            this.noDataFound = true;
            chart.noDataFound = true;
          } else {
            this.results[chartIndex].noDataFound = false;
            this.noDataFound = false;
            chart.noDataFound = false;
          }
        } else {
          if (fiveMomentsArray.fiveMomentsList.length === 2 && fiveMomentsArray.fiveMomentsList[0].list.length === 0 && chart.noDataFound) {
            this.noDataFound = true;
            chart.noDataFound = true;
          } else {
            this.results[chartIndex].noDataFound = false;
            this.noDataFound = false;
            chart.noDataFound = false;
          }
        }

        fiveMomentsArray.fiveMomentsList.forEach((fiveMoments) => {
          let fiveMomentsItem = fiveMoments;
          data.series[data.nextIndex].dataSetId = fiveMomentsItem.id;
          fiveMomentsItem.list.forEach((item) => {
            this.fiveMomentsMap.forEach(moment => {
              if (moment.checked) {
                let title = this.layoutService.translateText(moment.short);
                if (fiveMomentsItem.id >= 0 && fiveMomentsItem.name) {
                  title += " - " + this.layoutService.translateText(fiveMomentsItem.name);
                }

                if (!data.categoryAxis.categories.includes(title)) {
                  data.categoryAxis.categories.push(title);
                  data.categoryAxis.categoryOffset.push({ id: title, setId: fiveMoments.id });
                }

                switch (moment.key) {
                  case 'beforeTouchingPatient':
                    let beforeTouchingPatientCompliance = item.beforeTouchingPatientCompliance >= 0 ? item.beforeTouchingPatientCompliance : "NODATA"
                    data.series[data.nextIndex].data.push(beforeTouchingPatientCompliance);
                    data.series[data.nextIndex].dataOffset.push({ id: title, setId: fiveMomentsItem.id, value: beforeTouchingPatientCompliance });
                    data.seriesIdentifier[data.nextIndex].push({ id: title, setId: fiveMomentsItem.id });
                    break;
                  case 'beforeAsepticProcdures':
                    let beforeAsepticProceduresCompliance = item.beforeAsepticProceduresCompliance >= 0 ? item.beforeAsepticProceduresCompliance : "NODATA"
                    data.series[data.nextIndex].data.push(beforeAsepticProceduresCompliance);
                    data.series[data.nextIndex].dataOffset.push({ id: title, setId: fiveMomentsItem.id, value: beforeAsepticProceduresCompliance });
                    data.seriesIdentifier[data.nextIndex].push({ id: title, setId: fiveMomentsItem.id });
                    break;
                  case 'afterBodyFluidExposure':
                    let afterBodyFluidExposureCompliance = item.afterBodyFluidExposureCompliance >= 0 ? item.afterBodyFluidExposureCompliance : "NODATA"
                    data.series[data.nextIndex].data.push(afterBodyFluidExposureCompliance);
                    data.series[data.nextIndex].dataOffset.push({ id: title, setId: fiveMomentsItem.id, value: afterBodyFluidExposureCompliance });
                    data.seriesIdentifier[data.nextIndex].push({ id: title, setId: fiveMomentsItem.id });
                    break;
                  case 'afterTouchingPatient':
                    let afterTouchingPatientCompliance = item.afterTouchingPatientCompliance >= 0 ? item.afterTouchingPatientCompliance : "NODATA";
                    data.series[data.nextIndex].data.push(afterTouchingPatientCompliance);
                    data.series[data.nextIndex].dataOffset.push({ id: title, setId: fiveMomentsItem.id, value: afterTouchingPatientCompliance });
                    data.seriesIdentifier[data.nextIndex].push({ id: title, setId: fiveMomentsItem.id });
                    break;
                  case 'afterTouchingPatientSurroundings':
                    let afterTouchingPatientSurroundingsCompliance = item.afterTouchingPatientSurroundingsCompliance >= 0 ? item.afterTouchingPatientSurroundingsCompliance : "NODATA";
                    data.series[data.nextIndex].data.push(afterTouchingPatientSurroundingsCompliance);
                    data.series[data.nextIndex].dataOffset.push({ id: title, setId: fiveMomentsItem.id, value: afterTouchingPatientSurroundingsCompliance });
                    data.seriesIdentifier[data.nextIndex].push({ id: title, setId: fiveMomentsItem.id });
                    break;
                }
              }
            });
          });
        });

        let maxLength = data.categoryAxis.categoryOffset.length
        const combinedData = data.series.map(() => new Array(maxLength).fill(null));

        data.series.forEach((item, serieIndex) => {
          item.dataOffset.forEach((value, index) => {
            let indexOffset = data.categoryAxis.categoryOffset.findIndex(offset => offset.id === value.id && offset.setId === value.setId);
            combinedData[serieIndex][indexOffset] = value.value;
          });
        });

        for (let i = 0; i < combinedData.length; i++) {
          data.series[i].data = combinedData[i];
        }


        if (fiveMomentsArray.isBenchmark) {
          if (this.shouldHideBenchmarkData()) {
            return;
          }
          benchmarkCount++;
          const benchmarkName = `${this.data.filter && this.data.filter[benchmarkCount-1] ? this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' + this.data.filter[benchmarkCount-1].filterName : this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' +this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (benchmarkCount)}`
          data.series[data.nextIndex].name = [benchmarkName];
          data.series[data.nextIndex].filterName = [benchmarkName];
          data.series[data.nextIndex].filterNum = benchmarkCount;
        } else {
          filterCount++;
          data.series[data.nextIndex].name = [`${this.data.filter && this.data.filter[filterCount - 1] ? this.data.filter[filterCount - 1].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (filterCount)}`];
          data.series[data.nextIndex].filterName = [`${this.data.filter && this.data.filter[filterCount - 1] ? this.data.filter[filterCount - 1].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (filterCount)}`];
          data.series[data.nextIndex].filterNum = filterCount
        }

        data.categoryAxis.rotation = 0;
        data.categoryAxis.maxDivisions = 12;
        data.setId = chartId;
        data.nextIndex++;
        chart.chartOptions = data;
        chart.chartDatamani();

        let gridData: any[] = this.results[chartIndex].gridData;
        let fields = this.results[chartIndex].fields;
        let benchmarkFields = this.results[chartIndex].benchmarkFields;
        gridData = Object.assign([], gridData);
        if (fiveMomentsArray && !fiveMomentsArray.isBenchmark) {
          fiveMomentsArray.fiveMomentsList.forEach((element) => {
            let res2 = element.list;
            let multiName = '';
            let elementId = '';
            if (fiveMomentsArray.filterType && fiveMomentsArray.filterType != 'single') {
              multiName = element.name;
              elementId = element.id;
              if (element.list.length == 0 && element.noData == true) {
                multiName = 'EVALUATION.NO_DATA'
                elementId = 'nodata';
              }
              fields.push(
                { 'field': `column_filter_${filterTableCount + 1}_${elementId}_compliance`, 'title': 'DASHBOARD.COMPLIANCE', 'group': `${this.data.filter && this.data.filter[filterTableCount] ? this.data.filter[filterTableCount].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}`, multiName: multiName },
                { 'field': `column_filter_${filterTableCount + 1}_${elementId}_opportunities`, 'title': 'DASHBOARD.OPPORTUNITIES', 'group': `${this.data.filter && this.data.filter[filterTableCount] ? this.data.filter[filterTableCount].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}`, multiName: multiName },
                { 'field': `column_filter_${filterTableCount + 1}_${elementId}_positive`, 'title': 'EVALUATION.POSITIVE_ACTIONS', 'group': `${this.data.filter && this.data.filter[filterTableCount] ? this.data.filter[filterTableCount].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}`, multiName: multiName },
              );
              res2.forEach((item, i) => {
                if (gridData.length == 0) {
                  var beforeTouching = { name: this.layoutService.translateText('OBSERVATION.BEFORE.TOUCHING_PATIENT') }
                  var beforeAseptic = { name: this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1') }
                  var fluidExposure = { name: this.layoutService.translateText('OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK') }
                  var touchingPatient = { name: this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_PATIENT') }
                  var touchingSurroundings = { name: this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_SURROUNDINGS') }

                  beforeTouching[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.beforeTouchingPatientCompliance == -1 ? "N/A" : item.beforeTouchingPatientCompliance;
                  beforeTouching[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.beforeTouchingPatientOpportunities;
                  beforeTouching[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.beforeTouchingPatientPositive;

                  beforeAseptic[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.beforeAsepticProceduresCompliance == -1 ? "N/A" : item.beforeAsepticProceduresCompliance;
                  beforeAseptic[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.beforeAsepticProceduresOpportunities;
                  beforeAseptic[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.beforeAsepticProceduresPositive;

                  fluidExposure[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.afterBodyFluidExposureCompliance == -1 ? "N/A" : item.afterBodyFluidExposureCompliance;
                  fluidExposure[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.afterBodyFluidExposureOpportunities;
                  fluidExposure[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.afterBodyFluidExposurePositive;

                  touchingPatient[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.afterTouchingPatientCompliance == -1 ? "N/A" : item.afterTouchingPatientCompliance;
                  touchingPatient[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.afterTouchingPatientOpportunities;
                  touchingPatient[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.afterTouchingPatientPositive;

                  touchingSurroundings[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.afterTouchingPatientSurroundingsCompliance == -1 ? "N/A" : item.afterTouchingPatientSurroundingsCompliance;
                  touchingSurroundings[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.afterTouchingPatientSurroundingsOpportunities;
                  touchingSurroundings[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.afterTouchingPatientSurroundingsPositive;

                  gridData.push(beforeTouching, beforeAseptic, fluidExposure, touchingPatient, touchingSurroundings);
                } else {
                  this.fiveMomentsMap.forEach(moment => {
                    if (moment.checked) {
                      switch (moment.key) {
                        case 'beforeTouchingPatient':
                          let beforeTouchingIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.BEFORE.TOUCHING_PATIENT'));
                          if (beforeTouchingIndex != -1) {
                            gridData[beforeTouchingIndex][`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.beforeTouchingPatientCompliance == -1 ? "N/A" : item.beforeTouchingPatientCompliance;
                            gridData[beforeTouchingIndex][`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.beforeTouchingPatientOpportunities;
                            gridData[beforeTouchingIndex][`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.beforeTouchingPatientPositive;
                          } else {
                            var beforeTouching = { name: this.layoutService.translateText('OBSERVATION.BEFORE.TOUCHING_PATIENT') }
                            beforeTouching[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.beforeTouchingPatientCompliance == -1 ? "N/A" : item.beforeTouchingPatientCompliance;
                            beforeTouching[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.beforeTouchingPatientOpportunities;
                            beforeTouching[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.beforeTouchingPatientPositive;

                            gridData.unshift(beforeTouching);
                          }
                          break;
                        case 'beforeAsepticProcdures':
                          let beforeAsepticIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1'));
                          if (beforeAsepticIndex != -1) {
                            gridData[beforeAsepticIndex][`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.beforeAsepticProceduresCompliance == -1 ? "N/A" : item.beforeAsepticProceduresCompliance;
                            gridData[beforeAsepticIndex][`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.beforeAsepticProceduresOpportunities;
                            gridData[beforeAsepticIndex][`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.beforeAsepticProceduresPositive;
                          } else {
                            var beforeAseptic = { name: this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1') }
                            beforeAseptic[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.beforeAsepticProceduresCompliance == -1 ? "N/A" : item.beforeAsepticProceduresCompliance;
                            beforeAseptic[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.beforeAsepticProceduresOpportunities;
                            beforeAseptic[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.beforeAsepticProceduresPositive;

                            gridData.splice(1, 0, beforeAseptic);
                          }
                          break;
                        case 'afterBodyFluidExposure':
                          var afterBodyIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK'));
                          if (afterBodyIndex != -1) {
                            gridData[afterBodyIndex][`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.afterBodyFluidExposureCompliance == -1 ? "N/A" : item.afterBodyFluidExposureCompliance;
                            gridData[afterBodyIndex][`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.afterBodyFluidExposureOpportunities;
                            gridData[afterBodyIndex][`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.afterBodyFluidExposurePositive;
                          } else {
                            var fluidExposure = { name: this.layoutService.translateText('OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK') }
                            fluidExposure[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.afterBodyFluidExposureCompliance == -1 ? "N/A" : item.afterBodyFluidExposureCompliance;
                            fluidExposure[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.afterBodyFluidExposureOpportunities;
                            fluidExposure[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.afterBodyFluidExposurePositive;

                            gridData.splice(2, 0, fluidExposure);
                          }
                          break;
                        case 'afterTouchingPatient':
                          var afterTouchingIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_PATIENT'));
                          if (afterBodyIndex != -1) {
                            gridData[afterTouchingIndex][`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.afterTouchingPatientCompliance == -1 ? "N/A" : item.afterTouchingPatientCompliance;
                            gridData[afterTouchingIndex][`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.afterTouchingPatientOpportunities;
                            gridData[afterTouchingIndex][`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.afterTouchingPatientPositive;
                          } else {
                            var touchingPatient = { name: this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_PATIENT') }
                            touchingPatient[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.afterTouchingPatientCompliance == -1 ? "N/A" : item.afterTouchingPatientCompliance;
                            touchingPatient[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.afterTouchingPatientOpportunities;
                            touchingPatient[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.afterTouchingPatientPositive;

                            gridData.splice(3, 0, touchingPatient);
                          }
                          break;
                        case 'afterTouchingPatientSurroundings':
                          var afterSurroundingsIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_SURROUNDINGS'));
                          if (afterSurroundingsIndex != -1) {
                            gridData[afterSurroundingsIndex][`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.afterTouchingPatientSurroundingsCompliance == -1 ? "N/A" : item.afterTouchingPatientSurroundingsCompliance;
                            gridData[afterSurroundingsIndex][`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.afterTouchingPatientSurroundingsOpportunities;
                            gridData[afterSurroundingsIndex][`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.afterTouchingPatientSurroundingsPositive;
                          } else {
                            var touchingSurroundings = { name: this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_SURROUNDINGS') }
                            touchingSurroundings[`column_filter_${filterTableCount + 1}_${elementId}_compliance`] = item.afterTouchingPatientSurroundingsCompliance == -1 ? "N/A" : item.afterTouchingPatientSurroundingsCompliance;
                            touchingSurroundings[`column_filter_${filterTableCount + 1}_${elementId}_opportunities`] = item.afterTouchingPatientSurroundingsOpportunities;
                            touchingSurroundings[`column_filter_${filterTableCount + 1}_${elementId}_positive`] = item.afterTouchingPatientSurroundingsPositive;

                            gridData.push(touchingSurroundings);
                          }
                          break;
                      }
                    }
                  });
                }
              });
            } else {
              fields.push(
                { 'field': `column_filter_${filterTableCount + 1}_compliance`, 'title': 'DASHBOARD.COMPLIANCE', 'group': `${this.data.filter && this.data.filter[filterTableCount] ? this.data.filter[filterTableCount].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}` },
                { 'field': `column_filter_${filterTableCount + 1}_opportunities`, 'title': 'DASHBOARD.OPPORTUNITIES', 'group': `${this.data.filter && this.data.filter[filterTableCount] ? this.data.filter[filterTableCount].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}` },
                { 'field': `column_filter_${filterTableCount + 1}_positive`, 'title': 'EVALUATION.POSITIVE_ACTIONS', 'group': `${this.data.filter && this.data.filter[filterTableCount] ? this.data.filter[filterTableCount].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}` },
              );
              res2.forEach((item, i) => {
                if (gridData.length == 0) {
                  var beforeTouching = { name: this.layoutService.translateText('OBSERVATION.BEFORE.TOUCHING_PATIENT') }
                  var beforeAseptic = { name: this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1') }
                  var fluidExposure = { name: this.layoutService.translateText('OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK') }
                  var touchingPatient = { name: this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_PATIENT') }
                  var touchingSurroundings = { name: this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_SURROUNDINGS') }

                  beforeTouching[`column_filter_${filterTableCount + 1}_compliance`] = item.beforeTouchingPatientCompliance == -1 ? "N/A" : item.beforeTouchingPatientCompliance;
                  beforeTouching[`column_filter_${filterTableCount + 1}_opportunities`] = item.beforeTouchingPatientOpportunities;
                  beforeTouching[`column_filter_${filterTableCount + 1}_positive`] = item.beforeTouchingPatientPositive;

                  beforeAseptic[`column_filter_${filterTableCount + 1}_compliance`] = item.beforeAsepticProceduresCompliance == -1 ? "N/A" : item.beforeAsepticProceduresCompliance;
                  beforeAseptic[`column_filter_${filterTableCount + 1}_opportunities`] = item.beforeAsepticProceduresOpportunities;
                  beforeAseptic[`column_filter_${filterTableCount + 1}_positive`] = item.beforeAsepticProceduresPositive;

                  fluidExposure[`column_filter_${filterTableCount + 1}_compliance`] = item.afterBodyFluidExposureCompliance == -1 ? "N/A" : item.afterBodyFluidExposureCompliance;
                  fluidExposure[`column_filter_${filterTableCount + 1}_opportunities`] = item.afterBodyFluidExposureOpportunities;
                  fluidExposure[`column_filter_${filterTableCount + 1}_positive`] = item.afterBodyFluidExposurePositive;

                  touchingPatient[`column_filter_${filterTableCount + 1}_compliance`] = item.afterTouchingPatientCompliance == -1 ? "N/A" : item.afterTouchingPatientCompliance;
                  touchingPatient[`column_filter_${filterTableCount + 1}_opportunities`] = item.afterTouchingPatientOpportunities;
                  touchingPatient[`column_filter_${filterTableCount + 1}_positive`] = item.afterTouchingPatientPositive;

                  touchingSurroundings[`column_filter_${filterTableCount + 1}_compliance`] = item.afterTouchingPatientSurroundingsCompliance == -1 ? "N/A" : item.afterTouchingPatientSurroundingsCompliance;
                  touchingSurroundings[`column_filter_${filterTableCount + 1}_opportunities`] = item.afterTouchingPatientSurroundingsOpportunities;
                  touchingSurroundings[`column_filter_${filterTableCount + 1}_positive`] = item.afterTouchingPatientSurroundingsPositive;

                  gridData.push(beforeTouching, beforeAseptic, fluidExposure, touchingPatient, touchingSurroundings);
                } else {
                  this.fiveMomentsMap.forEach(moment => {
                    if (moment.checked) {
                      switch (moment.key) {
                        case 'beforeTouchingPatient':
                          let beforeTouchingIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.BEFORE.TOUCHING_PATIENT'));
                          if (beforeTouchingIndex != -1) {
                            gridData[beforeTouchingIndex][`column_filter_${filterTableCount + 1}_compliance`] = item.beforeTouchingPatientCompliance == -1 ? "N/A" : item.beforeTouchingPatientCompliance;
                            gridData[beforeTouchingIndex][`column_filter_${filterTableCount + 1}_opportunities`] = item.beforeTouchingPatientOpportunities;
                            gridData[beforeTouchingIndex][`column_filter_${filterTableCount + 1}_positive`] = item.beforeTouchingPatientPositive;
                          } else {
                            var beforeTouching = { name: this.layoutService.translateText('OBSERVATION.BEFORE.TOUCHING_PATIENT') }
                            beforeTouching[`column_filter_${filterTableCount + 1}_compliance`] = item.beforeTouchingPatientCompliance == -1 ? "N/A" : item.beforeTouchingPatientCompliance;
                            beforeTouching[`column_filter_${filterTableCount + 1}_opportunities`] = item.beforeTouchingPatientOpportunities;
                            beforeTouching[`column_filter_${filterTableCount + 1}_positive`] = item.beforeTouchingPatientPositive;

                            gridData.unshift(beforeTouching);
                          }
                          break;
                        case 'beforeAsepticProcdures':
                          let beforeAsepticIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1'));
                          if (beforeAsepticIndex != -1) {
                            gridData[beforeAsepticIndex][`column_filter_${filterTableCount + 1}_compliance`] = item.beforeAsepticProceduresCompliance == -1 ? "N/A" : item.beforeAsepticProceduresCompliance;
                            gridData[beforeAsepticIndex][`column_filter_${filterTableCount + 1}_opportunities`] = item.beforeAsepticProceduresOpportunities;
                            gridData[beforeAsepticIndex][`column_filter_${filterTableCount + 1}_positive`] = item.beforeAsepticProceduresPositive;
                          } else {
                            var beforeAseptic = { name: this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1') }
                            beforeAseptic[`column_filter_${filterTableCount + 1}_compliance`] = item.beforeAsepticProceduresCompliance == -1 ? "N/A" : item.beforeAsepticProceduresCompliance;
                            beforeAseptic[`column_filter_${filterTableCount + 1}_opportunities`] = item.beforeAsepticProceduresOpportunities;
                            beforeAseptic[`column_filter_${filterTableCount + 1}_positive`] = item.beforeAsepticProceduresPositive;

                            gridData.splice(1, 0, beforeAseptic);
                          }
                          break;
                        case 'afterBodyFluidExposure':
                          var afterBodyIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK'));
                          if (afterBodyIndex != -1) {
                            gridData[afterBodyIndex][`column_filter_${filterTableCount + 1}_compliance`] = item.afterBodyFluidExposureCompliance == -1 ? "N/A" : item.afterBodyFluidExposureCompliance;
                            gridData[afterBodyIndex][`column_filter_${filterTableCount + 1}_opportunities`] = item.afterBodyFluidExposureOpportunities;
                            gridData[afterBodyIndex][`column_filter_${filterTableCount + 1}_positive`] = item.afterBodyFluidExposurePositive;
                          } else {
                            var fluidExposure = { name: this.layoutService.translateText('OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK') }
                            fluidExposure[`column_filter_${filterTableCount + 1}_compliance`] = item.afterBodyFluidExposureCompliance == -1 ? "N/A" : item.afterBodyFluidExposureCompliance;
                            fluidExposure[`column_filter_${filterTableCount + 1}_opportunities`] = item.afterBodyFluidExposureOpportunities;
                            fluidExposure[`column_filter_${filterTableCount + 1}_positive`] = item.afterBodyFluidExposurePositive;

                            gridData.splice(2, 0, fluidExposure);
                          }
                          break;
                        case 'afterTouchingPatient':
                          var afterTouchingIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_PATIENT'));
                          if (afterBodyIndex != -1) {
                            gridData[afterTouchingIndex][`column_filter_${filterTableCount + 1}_compliance`] = item.afterTouchingPatientCompliance == -1 ? "N/A" : item.afterTouchingPatientCompliance;
                            gridData[afterTouchingIndex][`column_filter_${filterTableCount + 1}_opportunities`] = item.afterTouchingPatientOpportunities;
                            gridData[afterTouchingIndex][`column_filter_${filterTableCount + 1}_positive`] = item.afterTouchingPatientPositive;
                          } else {
                            var touchingPatient = { name: this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_PATIENT') }
                            touchingPatient[`column_filter_${filterTableCount + 1}_compliance`] = item.afterTouchingPatientCompliance == -1 ? "N/A" : item.afterTouchingPatientCompliance;
                            touchingPatient[`column_filter_${filterTableCount + 1}_opportunities`] = item.afterTouchingPatientOpportunities;
                            touchingPatient[`column_filter_${filterTableCount + 1}_positive`] = item.afterTouchingPatientPositive;

                            gridData.splice(3, 0, touchingPatient);
                          }
                          break;
                        case 'afterTouchingPatientSurroundings':
                          var afterSurroundingsIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_SURROUNDINGS'));
                          if (afterSurroundingsIndex != -1) {
                            gridData[afterSurroundingsIndex][`column_filter_${filterTableCount + 1}_compliance`] = item.afterTouchingPatientSurroundingsCompliance == -1 ? "N/A" : item.afterTouchingPatientSurroundingsCompliance;
                            gridData[afterSurroundingsIndex][`column_filter_${filterTableCount + 1}_opportunities`] = item.afterTouchingPatientSurroundingsOpportunities;
                            gridData[afterSurroundingsIndex][`column_filter_${filterTableCount + 1}_positive`] = item.afterTouchingPatientSurroundingsPositive;
                          } else {
                            var touchingSurroundings = { name: this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_SURROUNDINGS') }
                            touchingSurroundings[`column_filter_${filterTableCount + 1}_compliance`] = item.afterTouchingPatientSurroundingsCompliance == -1 ? "N/A" : item.afterTouchingPatientSurroundingsCompliance;
                            touchingSurroundings[`column_filter_${filterTableCount + 1}_opportunities`] = item.afterTouchingPatientSurroundingsOpportunities;
                            touchingSurroundings[`column_filter_${filterTableCount + 1}_positive`] = item.afterTouchingPatientSurroundingsPositive;

                            gridData.push(touchingSurroundings);
                          }
                          break;
                      }
                    }
                  });
                }
              });
            }

          });
        } else {
          fiveMomentsArray.fiveMomentsList.forEach((element) => {
            let res2 = element.list;
            let multiName = '';
            let elementId = '';
            if (fiveMomentsArray.filterType && fiveMomentsArray.filterType != 'single') {
              multiName = element.name;
              elementId = element.id;
              if (element.list.length == 0 && element.noData == true) {
                multiName = 'EVALUATION.NO_DATA'
                elementId = 'nodata';
              }
              const benchmarkName = `${this.data.filter && this.data.filter[benchmarkTableCount] ? this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' + this.data.filter[benchmarkTableCount].filterName : this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' +this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (benchmarkTableCount + 1)}`
              benchmarkFields.push(
                { 'field': `column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`, 'title': 'DASHBOARD.COMPLIANCE', 'group': benchmarkName, multiName: multiName },
                { 'field': `column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`, 'title': 'DASHBOARD.OPPORTUNITIES', 'group': benchmarkName, multiName: multiName },
                { 'field': `column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`, 'title': 'EVALUATION.POSITIVE_ACTIONS', 'group': benchmarkName, multiName: multiName },
              );

              res2.forEach((item, i) => {
                if (gridData.length == 0) {
                  var beforeTouching = { name: this.layoutService.translateText('OBSERVATION.BEFORE.TOUCHING_PATIENT') }
                  var beforeAseptic = { name: this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1') }
                  var fluidExposure = { name: this.layoutService.translateText('OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK') }
                  var touchingPatient = { name: this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_PATIENT') }
                  var touchingSurroundings = { name: this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_SURROUNDINGS') }

                  beforeTouching[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.beforeTouchingPatientCompliance == -1 ? "N/A" : item.beforeTouchingPatientCompliance;
                  beforeTouching[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.beforeTouchingPatientOpportunities;
                  beforeTouching[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.beforeTouchingPatientPositive;

                  beforeAseptic[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.beforeAsepticProceduresCompliance == -1 ? "N/A" : item.beforeAsepticProceduresCompliance;
                  beforeAseptic[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.beforeAsepticProceduresOpportunities;
                  beforeAseptic[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.beforeAsepticProceduresPositive;

                  fluidExposure[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.afterBodyFluidExposureCompliance == -1 ? "N/A" : item.afterBodyFluidExposureCompliance;
                  fluidExposure[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.afterBodyFluidExposureOpportunities;
                  fluidExposure[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.afterBodyFluidExposurePositive;

                  touchingPatient[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.afterTouchingPatientCompliance == -1 ? "N/A" : item.afterTouchingPatientCompliance;
                  touchingPatient[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.afterTouchingPatientOpportunities;
                  touchingPatient[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.afterTouchingPatientPositive;

                  touchingSurroundings[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.afterTouchingPatientSurroundingsCompliance == -1 ? "N/A" : item.afterTouchingPatientSurroundingsCompliance;
                  touchingSurroundings[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.afterTouchingPatientSurroundingsOpportunities;
                  touchingSurroundings[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.afterTouchingPatientSurroundingsPositive;

                  gridData.push(beforeTouching, beforeAseptic, fluidExposure, touchingPatient, touchingSurroundings);
                } else {
                  this.fiveMomentsMap.forEach(moment => {
                    if (moment.checked) {
                      switch (moment.key) {
                        case 'beforeTouchingPatient':
                          let beforeTouchingIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.BEFORE.TOUCHING_PATIENT'));
                          if (beforeTouchingIndex != -1) {
                            gridData[beforeTouchingIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.beforeTouchingPatientCompliance == -1 ? "N/A" : item.beforeTouchingPatientCompliance;
                            gridData[beforeTouchingIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.beforeTouchingPatientOpportunities;
                            gridData[beforeTouchingIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.beforeTouchingPatientPositive;
                          } else {
                            var beforeTouching = { name: this.layoutService.translateText('OBSERVATION.BEFORE.TOUCHING_PATIENT') }
                            beforeTouching[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.beforeTouchingPatientCompliance == -1 ? "N/A" : item.beforeTouchingPatientCompliance;
                            beforeTouching[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.beforeTouchingPatientOpportunities;
                            beforeTouching[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.beforeTouchingPatientPositive;

                            gridData.unshift(beforeTouching);
                          }
                          break;
                        case 'beforeAsepticProcdures':
                          let beforeAsepticIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1'));
                          if (beforeAsepticIndex != -1) {
                            gridData[beforeAsepticIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.beforeAsepticProceduresCompliance == -1 ? "N/A" : item.beforeAsepticProceduresCompliance;
                            gridData[beforeAsepticIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.beforeAsepticProceduresOpportunities;
                            gridData[beforeAsepticIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.beforeAsepticProceduresPositive;
                          } else {
                            var beforeAseptic = { name: this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1') }
                            beforeAseptic[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.beforeAsepticProceduresCompliance == -1 ? "N/A" : item.beforeAsepticProceduresCompliance;
                            beforeAseptic[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.beforeAsepticProceduresOpportunities;
                            beforeAseptic[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.beforeAsepticProceduresPositive;

                            gridData.splice(1, 0, beforeAseptic);
                          }
                          break;
                        case 'afterBodyFluidExposure':
                          var afterBodyIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK'));
                          if (afterBodyIndex != -1) {
                            gridData[afterBodyIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.afterBodyFluidExposureCompliance == -1 ? "N/A" : item.afterBodyFluidExposureCompliance;
                            gridData[afterBodyIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.afterBodyFluidExposureOpportunities;
                            gridData[afterBodyIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.afterBodyFluidExposurePositive;
                          } else {
                            var fluidExposure = { name: this.layoutService.translateText('OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK') }
                            fluidExposure[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.afterBodyFluidExposureCompliance == -1 ? "N/A" : item.afterBodyFluidExposureCompliance;
                            fluidExposure[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.afterBodyFluidExposureOpportunities;
                            fluidExposure[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.afterBodyFluidExposurePositive;

                            gridData.splice(2, 0, fluidExposure);
                          }
                          break;
                        case 'afterTouchingPatient':
                          var afterTouchingIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_PATIENT'));
                          if (afterBodyIndex != -1) {
                            gridData[afterTouchingIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.afterTouchingPatientCompliance == -1 ? "N/A" : item.afterTouchingPatientCompliance;
                            gridData[afterTouchingIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.afterTouchingPatientOpportunities;
                            gridData[afterTouchingIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.afterTouchingPatientPositive;
                          } else {
                            var touchingPatient = { name: this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_PATIENT') }
                            touchingPatient[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.afterTouchingPatientCompliance == -1 ? "N/A" : item.afterTouchingPatientCompliance;
                            touchingPatient[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.afterTouchingPatientOpportunities;
                            touchingPatient[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.afterTouchingPatientPositive;

                            gridData.splice(3, 0, touchingPatient);
                          }
                          break;
                        case 'afterTouchingPatientSurroundings':
                          var afterSurroundingsIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_SURROUNDINGS'));
                          if (afterSurroundingsIndex != -1) {
                            gridData[afterSurroundingsIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.afterTouchingPatientSurroundingsCompliance == -1 ? "N/A" : item.afterTouchingPatientSurroundingsCompliance;
                            gridData[afterSurroundingsIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.afterTouchingPatientSurroundingsOpportunities;
                            gridData[afterSurroundingsIndex][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.afterTouchingPatientSurroundingsPositive;
                          } else {
                            var touchingSurroundings = { name: this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_SURROUNDINGS') }
                            touchingSurroundings[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_compliance`] = item.afterTouchingPatientSurroundingsCompliance == -1 ? "N/A" : item.afterTouchingPatientSurroundingsCompliance;
                            touchingSurroundings[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_opportunities`] = item.afterTouchingPatientSurroundingsOpportunities;
                            touchingSurroundings[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_positive`] = item.afterTouchingPatientSurroundingsPositive;

                            gridData.push(touchingSurroundings);
                          }
                          break;
                      }
                    }
                  });
                }
              });
            } else {
              const benchmarkName = `${this.data.filter && this.data.filter[benchmarkTableCount] ? this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' + this.data.filter[benchmarkTableCount].filterName : this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' +this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (benchmarkTableCount + 1)}`
              benchmarkFields.push(
                { 'field': `column_benchmark_${benchmarkTableCount + 1}_compliance`, 'title': 'DASHBOARD.COMPLIANCE', 'group': benchmarkName },
                { 'field': `column_benchmark_${benchmarkTableCount + 1}_opportunities`, 'title': 'DASHBOARD.OPPORTUNITIES', 'group': benchmarkName },
                { 'field': `column_benchmark_${benchmarkTableCount + 1}_positive`, 'title': 'EVALUATION.POSITIVE_ACTIONS', 'group': benchmarkName },
              );

              res2.forEach((item, i) => {
                if (gridData.length == 0) {
                  var beforeTouching = { name: this.layoutService.translateText('OBSERVATION.BEFORE.TOUCHING_PATIENT') }
                  var beforeAseptic = { name: this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1') }
                  var fluidExposure = { name: this.layoutService.translateText('OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK') }
                  var touchingPatient = { name: this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_PATIENT') }
                  var touchingSurroundings = { name: this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_SURROUNDINGS') }

                  beforeTouching[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.beforeTouchingPatientCompliance == -1 ? "N/A" : item.beforeTouchingPatientCompliance;
                  beforeTouching[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.beforeTouchingPatientOpportunities;
                  beforeTouching[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.beforeTouchingPatientPositive;

                  beforeAseptic[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.beforeAsepticProceduresCompliance == -1 ? "N/A" : item.beforeAsepticProceduresCompliance;
                  beforeAseptic[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.beforeAsepticProceduresOpportunities;
                  beforeAseptic[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.beforeAsepticProceduresPositive;

                  fluidExposure[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.afterBodyFluidExposureCompliance == -1 ? "N/A" : item.afterBodyFluidExposureCompliance;
                  fluidExposure[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.afterBodyFluidExposureOpportunities;
                  fluidExposure[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.afterBodyFluidExposurePositive;

                  touchingPatient[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.afterTouchingPatientCompliance == -1 ? "N/A" : item.afterTouchingPatientCompliance;
                  touchingPatient[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.afterTouchingPatientOpportunities;
                  touchingPatient[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.afterTouchingPatientPositive;

                  touchingSurroundings[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.afterTouchingPatientSurroundingsCompliance == -1 ? "N/A" : item.afterTouchingPatientSurroundingsCompliance;
                  touchingSurroundings[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.afterTouchingPatientSurroundingsOpportunities;
                  touchingSurroundings[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.afterTouchingPatientSurroundingsPositive;

                  gridData.push(beforeTouching, beforeAseptic, fluidExposure, touchingPatient, touchingSurroundings);
                } else {
                  this.fiveMomentsMap.forEach(moment => {
                    if (moment.checked) {
                      switch (moment.key) {
                        case 'beforeTouchingPatient':
                          let beforeTouchingIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.BEFORE.TOUCHING_PATIENT'));
                          if (beforeTouchingIndex != -1) {
                            gridData[beforeTouchingIndex][`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.beforeTouchingPatientCompliance == -1 ? "N/A" : item.beforeTouchingPatientCompliance;
                            gridData[beforeTouchingIndex][`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.beforeTouchingPatientOpportunities;
                            gridData[beforeTouchingIndex][`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.beforeTouchingPatientPositive;
                          } else {
                            var beforeTouching = { name: this.layoutService.translateText('OBSERVATION.BEFORE.TOUCHING_PATIENT') }
                            beforeTouching[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.beforeTouchingPatientCompliance == -1 ? "N/A" : item.beforeTouchingPatientCompliance;
                            beforeTouching[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.beforeTouchingPatientOpportunities;
                            beforeTouching[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.beforeTouchingPatientPositive;

                            gridData.unshift(beforeTouching);
                          }
                          break;
                        case 'beforeAsepticProcdures':
                          let beforeAsepticIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1'));
                          if (beforeAsepticIndex != -1) {
                            gridData[beforeAsepticIndex][`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.beforeAsepticProceduresCompliance == -1 ? "N/A" : item.beforeAsepticProceduresCompliance;
                            gridData[beforeAsepticIndex][`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.beforeAsepticProceduresOpportunities;
                            gridData[beforeAsepticIndex][`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.beforeAsepticProceduresPositive;
                          } else {
                            var beforeAseptic = { name: this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1') }
                            beforeAseptic[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.beforeAsepticProceduresCompliance == -1 ? "N/A" : item.beforeAsepticProceduresCompliance;
                            beforeAseptic[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.beforeAsepticProceduresOpportunities;
                            beforeAseptic[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.beforeAsepticProceduresPositive;

                            gridData.splice(1, 0, beforeAseptic);
                          }
                          break;
                        case 'afterBodyFluidExposure':
                          var afterBodyIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK'));
                          if (afterBodyIndex != -1) {
                            gridData[afterBodyIndex][`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.afterBodyFluidExposureCompliance == -1 ? "N/A" : item.afterBodyFluidExposureCompliance;
                            gridData[afterBodyIndex][`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.afterBodyFluidExposureOpportunities;
                            gridData[afterBodyIndex][`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.afterBodyFluidExposurePositive;
                          } else {
                            var fluidExposure = { name: this.layoutService.translateText('OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK') }
                            fluidExposure[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.afterBodyFluidExposureCompliance == -1 ? "N/A" : item.afterBodyFluidExposureCompliance;
                            fluidExposure[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.afterBodyFluidExposureOpportunities;
                            fluidExposure[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.afterBodyFluidExposurePositive;

                            gridData.splice(2, 0, fluidExposure);
                          }
                          break;
                        case 'afterTouchingPatient':
                          var afterTouchingIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_PATIENT'));
                          if (afterBodyIndex != -1) {
                            gridData[afterTouchingIndex][`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.afterTouchingPatientCompliance == -1 ? "N/A" : item.afterTouchingPatientCompliance;
                            gridData[afterTouchingIndex][`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.afterTouchingPatientOpportunities;
                            gridData[afterTouchingIndex][`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.afterTouchingPatientPositive;
                          } else {
                            var touchingPatient = { name: this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_PATIENT') }
                            touchingPatient[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.afterTouchingPatientCompliance == -1 ? "N/A" : item.afterTouchingPatientCompliance;
                            touchingPatient[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.afterTouchingPatientOpportunities;
                            touchingPatient[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.afterTouchingPatientPositive;

                            gridData.splice(3, 0, touchingPatient);
                          }
                          break;
                        case 'afterTouchingPatientSurroundings':
                          var afterSurroundingsIndex = gridData.findIndex(item => item.name == this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_SURROUNDINGS'));
                          if (afterSurroundingsIndex != -1) {
                            gridData[afterSurroundingsIndex][`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.afterTouchingPatientSurroundingsCompliance == -1 ? "N/A" : item.afterTouchingPatientSurroundingsCompliance;
                            gridData[afterSurroundingsIndex][`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.afterTouchingPatientSurroundingsOpportunities;
                            gridData[afterSurroundingsIndex][`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.afterTouchingPatientSurroundingsPositive;
                          } else {
                            var touchingSurroundings = { name: this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_SURROUNDINGS') }
                            touchingSurroundings[`column_benchmark_${benchmarkTableCount + 1}_compliance`] = item.afterTouchingPatientSurroundingsCompliance == -1 ? "N/A" : item.afterTouchingPatientSurroundingsCompliance;
                            touchingSurroundings[`column_benchmark_${benchmarkTableCount + 1}_opportunities`] = item.afterTouchingPatientSurroundingsOpportunities;
                            touchingSurroundings[`column_benchmark_${benchmarkTableCount + 1}_positive`] = item.afterTouchingPatientSurroundingsPositive;

                            gridData.push(touchingSurroundings);
                          }
                          break;
                      }
                    }
                  });
                }
              });
            }

          });
        }

        if (fiveMomentsArray.isBenchmark) {
          benchmarkTableCount += 1;
        } else {
          filterTableCount += 1;
        }

        this.fiveMomentsMap.forEach(moment => {
          if (!moment.checked) {
            switch (moment.key) {
              case 'beforeTouchingPatient':
                gridData = gridData.filter(item => item.name != this.layoutService.translateText('OBSERVATION.BEFORE.TOUCHING_PATIENT'));
                break;
              case 'beforeAsepticProcdures':
                gridData = gridData.filter(item => item.name != this.layoutService.translateText('OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1'));
                break;
              case 'afterBodyFluidExposure':
                gridData = gridData.filter(item => item.name != this.layoutService.translateText('OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK'));
                break;
              case 'afterTouchingPatient':
                gridData = gridData.filter(item => item.name != this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_PATIENT'));
                break;
              case 'afterTouchingPatientSurroundings':
                gridData = gridData.filter(item => item.name != this.layoutService.translateText('OBSERVATION.AFTER.TOUCHING_SURROUNDINGS'));
                break;
            }
          }
        });

        this.results[chartIndex].gridData = gridData;
        this.results[chartIndex].fields = fields;
        this.results[chartIndex].benchmarkFields = benchmarkFields;
        this.results[chartIndex].resultChart = chart;

        setTimeout(() => {
          let complianceChart = this.compliance.charts.get(chartIndex);
          if (complianceChart) {
            complianceChart.chartDatamani();
          }
          this.compliance.setComplianceFields(this.results[chartIndex], 3, 3);
          this.compliance.setFilters(this.filters.toArray());

          if (index == res.length - 1) {
            this.compliance.resultsLoader.next(cloneDeep(this.results));
            if (this.exportTag) {
              this.exportTag.results = Object.assign([], this.results);
            }
          }

        }, 500);
      });
      this.evaluationLoaded = true;
      setTimeout(() => { this.initializeFilters(); }, 1000);
    }, 1000);

  }

  shouldHideBenchmarkDataByResponse(complianceList) {
    // If there is any response isBenchmark: true, then we should show benchmark data
    return complianceList.some(item => item.isBenchmark);
  }

  adjustResponseForEnvironment(res) {
    if (!this.isDesktop && res.length >= 2) {
      let spliceCount = 0;
      let idx = 1;
      res.forEach((fiveMomentsArray: any, index) => {
        if (index === 1) {
          if (fiveMomentsArray.isBenchmark === false) {
            spliceCount++;
          } else {
            idx = 2;
          }
        } else if (index === 2 || index === 3) {
          spliceCount++;
        }
      });
      return res.splice(idx, spliceCount);
    }
    return res;
  }

  initializeFilters() {
    this.selectedSeries = [];
    this.filters.forEach((filter, index) => {
      filter.visible = true;
    });

    this.evaluationService.getObserveEvaluationSeries(this.userID, "fivemoments").subscribe((seriesData: any) => {
      if (!seriesData || seriesData.selectedSeries == null) {
        this.layoutService.showLoader = false;
        return;
      }
      this.selectedSeries = JSON.parse(seriesData.selectedSeries);
      if (this.selectedSeries.length == 0) {
        this.layoutService.showLoader = false;
        return;
      }

      let chartSeries = JSON.parse(seriesData.selectedSeries);
      setTimeout(() => {
        chartSeries.forEach(serie => {
          if(typeof serie === 'number'){
              this.charts.forEach((chart) => {
                this.compliance.toggleVisibility(chart.chartId, {index: serie });
                chart.internalToggleSerie({ index: serie });
              });
          }else{
            let chart = this.charts.find(c => c.chartId === serie.chartId);
            if(!chart) return;
            serie.series.forEach((serie) => {
              chart.internalToggleSerie({ index: serie });
              this.compliance.toggleVisibility(chart.chartId, {index: serie });
            });
            this.filters.forEach((filter, index) => {
              if (index != serie.series) return;
              if (filter.visible == undefined) filter.visible = true;
              filter.visible = !filter.visible;
            });
          }
        });
      }, 1500);
    }, (error) => {
      this.layoutService.showLoader = false;
    }, () => {
      this.layoutService.showLoader = false;
    });
  }

  filterBenchmarkDataIfWardIsSelected(res): any {
    if (this.shouldHideBenchmarkData())
      return res.filter(item => !item.isBenchmark);
    else
      return res;
  }

  shouldHideBenchmarkData() {
    return this.anyWardIsSelected();
  }

  anyWardIsSelected() {
    for (let filterComponent of this.filters.toArray()) {
      if (filterComponent.isWardSelected()) {
        return true;
      }
    }
    return false;
  }

  onFilterRemoved(filterIndexToRemove: number) {
    const index = this.filterIndices.indexOf(filterIndexToRemove);

    if (index !== -1) {
      this.filterIndices.splice(index, 1);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    if (this.userHasFilter) {
      this.layoutService.showLoader = true;
      setTimeout(() => { this.evaluate(true); }, 1000);
    }
  }

  exportAs() {
    this.clickImageBtn = true;
  }

  excelDownload() {
    this.clickExcelBtn = true;
  }

  downloadKendoPDF() {
    this.clickPdfBtn = true;
  }

  resetFilters() {
    this.filterDetails = [this.filterDetails[0]];
    this.filterIndices = [0];
    this.filters.toArray()[0].resetFilter(true);
    this.fiveMomentsMap = this.fiveMomentsMap.map(moment => ({ ...moment, checked: true }));
    this.applyFiltersAndUpdateFiveMomentsShown();
    this.layoutService.showLoader = true;
    var seriesData = {
      userId: this.userID,
      complianceType: "fivemoments",
      selectedSeries: null
    };

    this.evaluationService.updateObserveEvaluationSeries(seriesData).subscribe(() => { 
      setTimeout(() => { this.evaluate(true); }, 1500);
    }, () => { }, () => { });
  }

  updateCheckboxState(momentKey: string, isChecked: boolean) {
    this.layoutService.showLoader = true;
    this.fiveMomentsMap.find(m => m.key === momentKey).checked = isChecked;
    this.applyFiltersAndUpdateFiveMomentsShown();
    setTimeout(() => { this.evaluate(true); }, 1000);
  }

  private applyFiltersAndUpdateFiveMomentsShown() {
    let data = this.prepareDataForUpdateFiveMomentsShown();
    this.updateFiveMomentsShown(true, this.userID, data);
  }

  private prepareDataForUpdateFiveMomentsShown() {
    const momentsChecked = this.fiveMomentsMap.reduce((acc, moment) => ({ ...acc, [moment.key]: moment.checked }), {});

    let data = {
      filter: [],
      isBenchMark: true,
      fiveMomentsShown: momentsChecked
    };

    this.filters.forEach((filter) => {
      let filterData = {
        startDate: filter.range.start,
        endDate: filter.range.end,
        instutionIDs: "",
        departmentID: "",
        wardID: "",
        professionalCategoryID: "",
        subprofessionalCategoryID: "",
        countryID: 0
      };

      if (this.roleId == 1 && filter.setCountry != 0) {
        filterData.countryID = filter.setCountry.countryID;
      }
      filterData = filter.assignData(filterData);
      data.filter.push(filterData);
    });
    return data;
  }

  originalFields: any[] = null;
  originalBenchmarkFields: any[] = null;
  selectedSeries: any[] = [];

  onSeriesClick(serie: any, resultIndex: number) {
    let chart = this.charts.find( c => c.chartId == serie.chartId);
    chart.series.get(serie.index).options.visible = serie.visible;
    
    this.filters.forEach((filter, index) => {
      if (index != serie.index) return;
      if (filter.visible == undefined) filter.visible = true;
      filter.visible = !filter.visible;
    });

    this.compliance.toggleVisibility(serie.chartId,serie);

    let visibilitySeries = [];

    this.charts.forEach((chart) => {
      let c = {
        chartId: chart.chartId,
        series: chart.series.map((s, index) => ({ series: s, index }))
                            .filter(s => s.series.options.visible === false)
                            .map(s => s.index)
      }
      visibilitySeries.push(c);
    })

    var seriesData = {
      userId: this.userID,
      complianceType: "fivemoments",
      selectedSeries: JSON.stringify(visibilitySeries)
    };

    this.evaluationService.updateObserveEvaluationSeries(seriesData).subscribe(() => { }, () => { }, () => { });
  }

  onFilterSaved() {
    // Buscar nombres duplicados y renombrar los duplicados
    const renamedFilters: string[] = [];
    var filters = this.filters.toArray();
    // Recorre desde el último hasta el primero
    for (let i = filters.length - 1; i >= 0; i--) {
      const currentName = filters[i].filterName?.trim() || '';
      for (let j = 0; j < filters.length; j++) {
        if (i !== j && currentName && currentName === (filters[j].filterName?.trim() || '')) {
          // Si hay coincidencia, renombra el actual
          const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (i + 1);
          filters[i].filterName = translatedFilterName;
          filters[i].setFilterName = translatedFilterName;          
          renamedFilters.push(translatedFilterName);
          break;
        }
      }
    }

    if (renamedFilters.length > 0) {
        const f = renamedFilters[renamedFilters.length - 1];
        const msg = `${this.layoutService.translateText('EVALUATION.FILTER_DUPLICATED_NAME')} '${f}'.`;
        this.layoutService.showWarning(msg);
    }
    this.evaluate(true);
  }

  onRefreshClick(noDataFound: boolean) {
    if (noDataFound) {
      return;
    }

    this.evaluate(true);
  }

  saveSummarisedReport() {
    if (this.userHasFilter) {
      this.evaluate(false);
    }
  }

  trackLoop(index: number, item: any) {
    return item;
  }
}
